import {
  ModulesQuery,
  OrganizationBillableCptCodesQuery,
  OrganizationFormSchedulesQuery,
  OrganizationFormsQuery,
  OrganizationMessagesQuery,
  OrganizationNotesQuery,
  OrganizationServicesQuery,
  OrganizationSessionsQuery,
  PatientsQuery,
  SearchDefaultTemplatesQuery,
  TranscriptsQuery,
} from '@graphQLGenerated'

import { ArrayElement } from './utils'

export enum EmojiType {
  neutral = 'neutral',
  awful = 'awful',
  unhappy = 'unhappy',
  anxious = 'anxious',
  okay = 'okay',
  content = 'content',
  happy = 'happy',
  neutralGhost = 'neutralGhost',
}

export type CFormSelectOption = {
  disabled?: boolean
  label?: string
  value?: string
}

export type ThemeColor =
  | 'primary'
  | 'secondary'
  | 'success'
  | 'danger'
  | 'warning'
  | 'info'
  | 'dark'
  | 'light'
  | string

export enum PatientDetailTabs {
  overview = 'overview',
  assignments = 'assignments',
  health = 'health',
  notes = 'notes',
  billing = 'billing',
  techniques = 'techniques',
}

export enum GroupDetailTabs {
  overview = 'overview',
  notes = 'notes',
}

export enum SettingsTabs {
  onlinePayments = 'online-payments',
  services = 'services',
  preferences = 'preferences',
  subscription = 'subscription',
}

export enum BillsTabs {
  invoices = 'Invoices',
  superbills = 'superbills',
}

export enum CBTLibraryPages {
  templates = 'templates',
  myLibrary = 'my-library',
}

export enum DateRanges {
  allTime = 'ALL_TIME',
  thirtyDays = '30_DAYS',
  thisMonth = 'THIS_MONTH',
  lastMonth = 'LAST_MONTH',
  thisYear = 'THIS_YEAR',
  lastYear = 'LAST_YEAR',
  customRange = 'CUSTOM_RANGE',
}

export enum FormBuilderViews {
  library = 'library',
  generator = 'generator',
  preview = 'preview',
}

export type OrganizationServicesQueryElement = ArrayElement<
  OrganizationServicesQuery['organizationServices']
>

export type OrganizationSessionsQueryElement = ArrayElement<
  OrganizationSessionsQuery['organizationSessions']
>

export type OrganizationNotesQueryElement = ArrayElement<
  OrganizationNotesQuery['organizationNotes']
>

export type PatientsQueryElement = ArrayElement<PatientsQuery['patients']>

export type OrganizationBillableCptCodesQueryElement = ArrayElement<
  OrganizationBillableCptCodesQuery['organizationBillableCptCodes']
>

export type OrganizationMessagesQueryElement = ArrayElement<
  OrganizationMessagesQuery['organizationMessages']
>

export type DefaultTemplatesQueryElement = ArrayElement<
  SearchDefaultTemplatesQuery['searchDefaultTemplates']
>

export type OrganizationFormsQueryElement = ArrayElement<
  OrganizationFormsQuery['organizationForms']
>

export type ModulesQueryElement = ArrayElement<ModulesQuery['modules']>

export type TranscriptsQueryElement = ArrayElement<TranscriptsQuery['transcripts']>

export type OrganizationFormScheduleQueryElement = ArrayElement<
  OrganizationFormSchedulesQuery['organizationFormSchedules']
>
